export type UploadReason = {
  value: string;
  name: string;
  enum: string;
  fileName: string;
  minSize?: number;
  maxSize?: number;
};

export const uploadReasons: UploadReason[] = [
  {
    value: '1',
    name: 'Boleto de quitação',
    enum: 'PAYMENTSLIP',
    fileName: 'boleto-quitação.pdf',
    minSize: 50,
    maxSize: 220,
  },
  {
    value: '2',
    name: 'Comprovante de CPF',
    enum: 'CPFPROOF',
    fileName: 'comprovante situação cadastral.pdf',
    minSize: 60,
    maxSize: 100,
  },
  {
    value: '3',
    name: 'Aditivo contratual',
    enum: 'CONTRACTAMENDMENT',
    fileName: 'aditivo-contratual.pdf',
    maxSize: 200,
  },
];

export const findUploadReason = (value?: string | number | null): UploadReason | undefined =>
  value === null || value === undefined ? undefined : uploadReasons.find((reason) => reason.value === String(value));
